import { useNavigate } from 'react-router-dom'
import styles from './StatusProject.module.css'
import Button from '../UI/Button/Button'
import { ReactComponent as Logo } from '../../assets/icons/LogoStatus.svg'
import { ReactComponent as HoverLogo } from '../../assets/icons/whiteStatus.svg'
import { PROJECT_STATUS_PAGE } from '../../router/paths'

export default function StatusProject() {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(PROJECT_STATUS_PAGE);
  };
  return (
    <div className={styles.wrapper}>
      <Button roundType="small_rounded" width="311px" onClick={handleCardClick}>
        Узнать больше о проекте
      </Button>
      <Logo className={styles.logo}></Logo>
      <HoverLogo className={styles.absolute_logo}></HoverLogo>
    </div>
  )
}
